import { isAfter, isBefore } from 'date-fns';
export function isInRange(date, param) {
    let { endDate, startDate } = param;
    return !isAfter(date, endDate) && !isBefore(date, startDate);
}
